import { render } from "./FormLink.vue?vue&type=template&id=32b3d021"
import script from "./FormLink.vue?vue&type=script&lang=js"
export * from "./FormLink.vue?vue&type=script&lang=js"

import "./FormLink.vue?vue&type=style&index=0&id=32b3d021&lang=css"

import exportComponent from "C:\\Users\\ma-dg\\Desktop\\wa\\ask_wizard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__